import { StatePreV17, StateV17 } from './17_migrate_show_elementarfragebogen.interface';

export const migrateShowElementarfragebogen = (
  previousState: StatePreV17,
  newVersion: number,
): StateV17 => {
  // Vor Einführung von showElementarfragebogen/showNebengebaeude gab es nur isUnderwriterInfoVisible,
  // und Nebengebäude-UW existierte als Konzept noch nicht — jeder sichtbare UW-Fall war also ein Ele-Fall.
  const migratedWarenkorb = previousState.warenkorb.map(angebot => ({
    ...angebot,
    showElementarfragebogen:
      angebot.showElementarfragebogen ?? Boolean(angebot.isUnderwriterInfoVisible),
  }));

  return {
    ...previousState,
    version: newVersion,
    warenkorb: migratedWarenkorb,
  } as StateV17;
};
